
// Project Module Getters
const getters = {
  collection: state => {
    return state.collection
  }
}

export default getters



// WEBPACK FOOTER //
// ./src/store/notification/getters.js